import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActiveWorkspaceService } from './active-workspace.service';

/**
 * Hängt den Header `X-Active-Workspace-Id` an Backend-API-Requests, wenn im
 * ActiveWorkspaceService ein Workspace gewählt ist. Damit scopt der Server
 * geteilte Spezialtool-Daten auf den aktiven Workspace (serverseitig validiert).
 */
export const activeWorkspaceInterceptorFn: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/')) {
    return next(req);
  }

  let workspaceId: number | null = null;
  try {
    workspaceId = inject(ActiveWorkspaceService).snapshot();
  } catch {
    // Service nicht verfügbar → nichts anhängen
  }

  if (workspaceId == null || req.headers.has('X-Active-Workspace-Id')) {
    return next(req);
  }

  return next(req.clone({
    headers: req.headers.set('X-Active-Workspace-Id', String(workspaceId)),
  }));
};
